module.exports = __webpack_public_path__ + "static/media/toshiba_iPhone5c.8fbc9f39.jpg";